import { Controller } from "@hotwired/stimulus";
import BaseController from "confinus_ui/base_controller";
import { markAsSafeHTML } from "lib/util/safe_html";
import { Category } from "lib/types";
import { DecorSuiteFormsSelectIdentifier } from "decor";

// Minimal duck-type of the Decor::Suite select controller surface used here.
interface SuiteSelectController extends Controller {
  disabled: boolean;
  value: string;
  options: string;
  optionsHTML: string;
  empty(label: string): void;
}

export default class ProductCategoryFilterTierController extends BaseController {
  public static values = {
    categories: Array,
  };

  declare public categoriesValue: Category[];
  public static outlets = [DecorSuiteFormsSelectIdentifier];
  declare private readonly decorSuiteFormsSelectOutlet: SuiteSelectController;

  public onInitialize() {
    return super.onInitialize();
  }

  public set disabled(disabled: boolean) {
    if (disabled) {
      this.decorSuiteFormsSelectOutlet.empty("Category");
    }

    this.decorSuiteFormsSelectOutlet.disabled = disabled;
  }

  public set options(newOptions: Category[]) {
    this.categoriesValue = newOptions;

    if (newOptions.length === 0) {
      this.disabled = true;
      return;
    }

    this.decorSuiteFormsSelectOutlet.empty("Category");
    const newHtml = newOptions
      .map((category) => `<option value='${category.i}'>${category.n}</option>`)
      .reduce((previous, current) => (previous += current));

    // Decor's Select#options setter accepts a raw string (it innerHTMLs the
    // value directly). Keep the markAsSafeHTML wrap as a Confinus-side XSS
    // guardrail — the explicit `__safe` flag in safe_html.ts forces every
    // call site to acknowledge the trust boundary in code review — and
    // unwrap to `.content` only at the Decor boundary.
    this.decorSuiteFormsSelectOutlet.options = markAsSafeHTML(
      this.decorSuiteFormsSelectOutlet.optionsHTML + newHtml,
    ).content;
    this.disabled = false;
  }

  public get value(): string {
    return this.decorSuiteFormsSelectOutlet.value;
  }
}
